import Vue from 'vue';

function visibilityChangeHandler(vm: Vue) {
    let pagehide = true;
    const handler = () => {
        try {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            pagehide = window.document.hidden || window.document.webkitHidden;
        } catch (e) {
            console.info(e);
        }

        if (!pagehide) {
            vm.$emit('page-visibility-show');
        } else {
            vm.$emit('page-visibility-hidden');
        }
    };
    window.document.addEventListener('visibilitychange', handler);

    return () => {
        window.document.removeEventListener('visibilitychange', handler);
    };
}

export default {
    mounted() {
        this.$cancelVisilityChange = visibilityChangeHandler(this);
    },

    destroyed() {
        this.$cancelVisilityChange();
    }
};
